/**
 * @fileoverview ライセンスを表示するモーダルウィンドウ
 */
import { useEffect, useState } from "react";
import "./LicenceModal.css";

/**
 * ライセンスを表示するモーダルウィンドウのプロパティ
 */
interface LicenceModalProps {
  isOpen: boolean;
  onClose: () => void;
}

/**
 * ライセンスを表示するモーダルウィンドウ
 * @param {LicencesModalProps} props
 * @returns {JSX.Element} ライセンスを表示するモーダルウィンドウのJSX要素
 */
const LicenceModal: React.FC<LicenceModalProps> = ({ isOpen, onClose }) => {
  const [licenses, setLicenses] = useState<any[]>([]);

  useEffect(() => {
    if (isOpen) {
      fetch("/licenses.json", { cache: "no-store" })
        .then((response) => response.json())
        .then((data) => setLicenses(Object.entries(data)));
    }
  }, [isOpen]);

  if (!isOpen) return null;

  return (
    <div className="modal-overlay">
      <div className="modal-content">
        <div className="modal-header">
          <button className="modal-close" onClick={onClose}>
            &times;
          </button>
          <h2>OSS Licence</h2>
        </div>
        <div className="modal-body">
          {licenses.length > 0 ? (
            <ul>
              {licenses.map(([packageName, licenseInfo]) => (
                <li key={packageName} className="lisence-text">
                  <strong>{packageName}</strong>:{licenseInfo.licenses}
                  {licenseInfo.repository ? (
                    <>
                      <br />

                      {licenseInfo.repository}
                    </>
                  ) : null}
                </li>
              ))}
            </ul>
          ) : (
            <p>Loading...</p>
          )}
        </div>
      </div>
    </div>
  );
};

export default LicenceModal;
